module.exports = __webpack_public_path__ + "images/5a5443ac2498be8398938e281a3eaf2407301b8091217b338fa57f038bd215f2.svg";